import axios from "axios";
import tokenService from "./token.service";

const setAuthToken = (token) => {
  if (token) {
    axios.defaults.headers.common.Authorization = `Bearer $`;
  } else {
    delete axios.defaults.headers.common.Authorization;
  }
};

const instance = axios.create({
  baseURL: `${import.meta.env.VITE_APP_API_URL}/`, //devURL

  // timeout: 1000 * 20, // reqeust/response timeout to 20 sec
  headers: {
    "Content-type": "multipart/form-data",
    source: 0,
  },
});

instance.interceptors.request.use(
  (config) => {
    const token = tokenService.getLocalAccessToken();
    const userType = sessionStorage.getItem("userSelectType");
    const autoTokken = sessionStorage.getItem("tokkenValue");
    config.headers["token"] = autoTokken ? autoTokken : "";
    if (token) {
      config.headers["token"] = "";
      config.headers["auth-token"] = token;
      config.headers["x-access-token"] = token;
      config.headers["user-type"] = userType;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default setAuthToken;
export { instance };
